module.exports = __webpack_public_path__ + "827e7cd76163f23ae4b74cae0f8ceba0.pdf";